import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { tap, map, catchError } from 'rxjs/operators'
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { JwtService } from '../../../../../shared/services/jwt.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { environment } from '../../../../../../environments/environment';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
import { StorageKeyEnum } from '../../../../../shared/enums/storage-key.enum';
import { PermissionNavigationService } from '../../../../../shared/services/permission-navigation.service';
import { verifyHostBindings } from '@angular/compiler';
import { throwError } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private router: Router,
        private storageService: StorageService,
        private jwtService: JwtService,
        private httpClient: HttpClient,
        private headerBasicAuthorization: HeaderBasicAuthorizationService,
        private permissionNavigationService: PermissionNavigationService) { }

    private handleError(error: HttpErrorResponse) {
        console.log("fresco y tropical")
            if (error.status === 0) {
              // A client-side or network error occurred. Handle it accordingly.
              console.error('An error occurred:', error.error);
            } else {
              // The backend returned an unsuccessful response code.
              // The response body may contain clues as to what went wrong.
              console.error(
                `Backend returned code ${error.status}, body was: `, error.error);
            }
            // Return an observable with a user-facing error message.
            return throwError(() => new Error('Something bad happened; please try again later.'));
        }

    login(login: string, password: string, sociedad: number) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/login`,
            {
                userName: login,
                password: password,
                sociedad: sociedad
            }, {}
        )
            .pipe(
                map((response: any) => {
                    if (response.response) {
                        this.storageService.set(StorageKeyEnum.JWT_AUTHORIZATION, response.token);
                        this.storageService.set(StorageKeyEnum.UsuarioID, response.usuarioID);
                        this.storageService.set(StorageKeyEnum.Nombre, response.nombreCompleto);
                        this.storageService.set(StorageKeyEnum.Email, response.email);
                        this.storageService.set(StorageKeyEnum.Login, response.username);
                        this.storageService.set(StorageKeyEnum.DocIdentidad, response.DocIdentidad);
                        this.storageService.set(StorageKeyEnum.Expiration, response.expiration);
                        this.storageService.set(StorageKeyEnum.Loocked, response.loocked);
                        this.storageService.set(StorageKeyEnum.Type, response.type);
                        this.storageService.set(StorageKeyEnum.Empresa, response.empresaId);
                        this.jwtService.load(response.token);
                    }
                    return response
                }),
                catchError((error, caught) => {
                    return throwError(error);
                  })
            )
    }


    logoff() {
        this.permissionNavigationService.reset();
        this.storageService.remove(StorageKeyEnum.JWT_AUTHORIZATION);
        this.storageService.remove(StorageKeyEnum.UsuarioID);
        this.storageService.remove(StorageKeyEnum.Nombre);
        this.storageService.remove(StorageKeyEnum.Email);
        this.storageService.remove(StorageKeyEnum.Login);
        this.storageService.remove(StorageKeyEnum.DocIdentidad);
        this.storageService.remove(StorageKeyEnum.Expiration);
        this.storageService.remove(StorageKeyEnum.Loocked);
        this.storageService.remove(StorageKeyEnum.Empresa);
        this.jwtService.clear();
    }

    refreshToken() {
        return this.httpClient.get(`${environment.api.WS_IT.url}/Usuario/RefreshToken`, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }).pipe(
            tap((response: any) => {
                if (response.response) {
                    this.storageService.set(StorageKeyEnum.JWT_AUTHORIZATION, response.token);
                    this.storageService.set(StorageKeyEnum.Expiration, response.expiration);
                    this.storageService.set(StorageKeyEnum.Loocked, response.loocked);
                    this.storageService.set(StorageKeyEnum.Type, response.type);
                    this.jwtService.load(response.JWT);
                }
            })
        );
    }

    forgotPassword(UserName: string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/RecoveryPassword`,
            {
                UserName: UserName
            }, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }
        )
    }

    changePassword(passwordActual: string, passwordNueva: string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/UpdatePassword`,
            {
                PasswordActual: passwordActual,
                Password: passwordNueva,
                SecondPassword: passwordNueva
            }, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }
        )
    }

    resetPassword(Usuario: string, Password: string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/UpdateForgottenPassword`,
            {
                UserId: Usuario,
                Password: Password
            }, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }
        )
    }

    findPermisosRoot() {
        return ['/', '/profile', '/change-password'];
    }

    findPermissions() {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Rol/GetPermissions`, {
            params: {
            },
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        });
    }

    findPermisos(application: string) {
        return this.httpClient.get(`${environment.api.WS_IT.url}/ZITG_ObtenerOpcionesUsuario`, {
            params: {
                prmstrApplication: application
            },
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        });
    }

    isLoggedIn() {
        let jwt: string = this.storageService.get(StorageKeyEnum.JWT_AUTHORIZATION);
        if (jwt != null) {
            return this.validate(this.storageService.get(StorageKeyEnum.Expiration),Number(this.storageService.get(StorageKeyEnum.Loocked)))
        } else {
            return false;
        }
    }

    redirectToLogin() {
        this.router.navigate(['/login']);
    }

    redirectToMain() {
        this.router.navigate(['/welcome']);
    }
    redirectToChangePw() {
        this.router.navigate(['/change-password']);
    }

    redirectToNotAllowed() {
        this.router.navigate(['/error/not-allowed']);
    }
    validate(date: any, loocked: any){
        var today = new Date()
        if(date == null){
            return false
        }
        if(today<new Date(date) || loocked == 1){
            return true
        }else{
            return false
        }
    }

    public listarPais() {
        return this.httpClient.get(`${environment.api.WS_IT.url}/Usuario/PaisesList`,
          {}).pipe(map(response => response));
    }

    public recoveryPassword(token: string, password: string, secondPassword:string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/UpdatePasswordFromMail`,
            {
                Token: token,
                Password: password,
                SecondPassword: secondPassword,
            }, {headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)});
    }

    public login2Factor(usuario: string, codigo: number) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/Login2FA`,
            {
                Username: usuario,
                Token: codigo,
            }, {headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)})
            .pipe(
                map((response: any) => {
                    if (response.response) {
                        this.storageService.set(StorageKeyEnum.JWT_AUTHORIZATION, response.token);
                        this.storageService.set(StorageKeyEnum.UsuarioID, response.usuarioID);
                        this.storageService.set(StorageKeyEnum.Nombre, response.nombreCompleto);
                        this.storageService.set(StorageKeyEnum.Email, response.email);
                        this.storageService.set(StorageKeyEnum.Login, response.username);
                        this.storageService.set(StorageKeyEnum.DocIdentidad, response.DocIdentidad);
                        this.storageService.set(StorageKeyEnum.Expiration, response.expiration);
                        this.storageService.set(StorageKeyEnum.Loocked, response.loocked);
                        this.storageService.set(StorageKeyEnum.Type, response.type);
                        this.jwtService.load(response.token);
                    }
                    return response
                }),
                catchError((error, caught) => {
                    return throwError(error);
                  })
            );
    }

    redirectToLogin2Factor(usuario: string) {
        this.router.navigate(["/login2FA"], {queryParams: {User: usuario}});
    }

    getUserByUserName(usuario: string){
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/GetUserByUserName`,
                {usuario: usuario},{})
                .pipe(map(response => response));
    }

    getCodigo2FA(usuario: string, tipo: number){
        return this.httpClient.post(`${environment.api.WS_IT.url}/Usuario/ObtenerCodigo2FA`,
                {   
                    Usuario: usuario,
                    Tipo: tipo
                },{})
                .pipe(map(response => response));
    }

    GetSleepIdleMinutes() {
        return this.httpClient.get(`${environment.api.WS_IT.url}/Usuario/GetSleepIdleMinutes`, {headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)});
    }
}